import { h } from 'preact';
import { Link } from 'wouter-preact';
import { useHashLocation } from 'wouter-preact/use-hash-location';

import { IconUserCircleOutline } from '../../../common/icons/icon-user-circle-outline';
import { useTranslation } from '../../../i18n';

export const PerksMyAcctNavLink = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation();
  const [location] = useHashLocation();

  return (
    <li
      className={`my-account ${location === '/my-account' ? 'active' : ''}`}
      id="single-my-account-tab"
    >
      <Link to="/my-account" title={t('perks.myAccount')} onClick={onClick}>
        <div>
          <IconUserCircleOutline />
          <span class="h5 single-h5">{t('perks.myAccount')}</span>
        </div>
      </Link>
    </li>
  );
};
